import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import axios from "axios";
import CountUp from "react-countup";
import Widget from "../../../../../components/Widget/Widget";

const PageVideos = () => {
  const [pageVideosData, setPageVideosData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async (firstLoad) => {
    if(firstLoad){
      setLoading(true);
    }
    try {
      const response = await axios.get(
        "https://eadash.arabiansystems.com/api/Dashboard/FacebookAnalytics/PageVideos"
      );
      const data = response.data;
      setPageVideosData(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  useEffect(() => {
    fetchData(true);
    const interval = setInterval(() => {
      fetchData(false);
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Widget fetchingData={loading}>
      <div className="clearfix height150 relativeDiv" >
        <Row className="flex-nowrap">
          <Col xs={3}>
          <img src="/icons/video.png" width={window.innerWidth < 1576 ? "40" : "60"} />

          </Col>
          <Col xs={9}>
            <h6 className="m-0">Total Videos Views</h6>
            <p className="h2 m-0 fw-normal">
              <CountUp
                start={0}
                end={pageVideosData?.totalViews}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </p>
          </Col>
        </Row>
        {/* <Row className="flex-nowrap marginTop36">
          <Col xs="6">
            <h6 className="m-0">Current Month</h6>
            <p className="value5">
              <CountUp
                start={0}
                end={pageVideosData?.currentMonthViews}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </p>
          </Col>
          <Col xs={6}>
            <h6 className="m-0">Previous Month</h6>
            <p className="value5">
              <CountUp
                start={0}
                end={pageVideosData?.previousMonthViews}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </p>
          </Col>
        </Row> */}
        <Row>
          <Col xs={12}>
            <div className="marginTop10 infoFlex absoDiv">
              <i class="fa fa-info-circle"></i>
              <p className="m-0">Based on data from the last 30 days</p>
            </div>
          </Col>
        </Row>
      </div>
    </Widget>
  );
};

export default PageVideos;
